"use client";

import { CountryInfo } from "@/store/types/countryTypes";
import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

const CountryFaqs: React.FC<{ country: CountryInfo }> = ({ country }) => {
  const sectionData = country?.faqsSection;

  const items = sectionData?.items || [];

  if (items.length === 0) {
    return null;
  }

  const heading = sectionData?.heading || "Frequently Asked Questions";
  const subheading = sectionData?.subheading;

  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleAccordion = (idx: number) => {
    setOpenIndex((prev) => (prev === idx ? null : idx));
  };

  return (
    <div className="w-full my-12 space-y-6">
      <div>
        <h2 className="text-2xl sm:text-3xl font-bold text-[#1C2233] ff_poppins">
          {heading}
        </h2>
        {subheading && (
          <p className="mt-1.5 text-xs sm:text-sm text-[#667085] ff_poppins">
            {subheading}
          </p>
        )}
      </div>

      <div className="space-y-3">
        {items.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return (
            <div
              key={idx}
              className="bg-white rounded-[16px] border border-[#E0D8FF] overflow-hidden shadow-xs transition-all"
            >
              <button
                onClick={() => toggleAccordion(idx)}
                className="w-full py-4.5 px-6 flex items-center justify-between text-left gap-4 focus:outline-none cursor-pointer"
              >
                <span className="text-sm sm:text-base font-bold text-[#1C2233] ff_poppins">
                  {faq.question}
                </span>

                <div className="w-7 h-7 rounded-full bg-[#FFF3EA] border border-[#FFE1CD] flex items-center justify-center text-[#FF7043] shrink-0">
                  {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                </div>
              </button>

              {isOpen && (
                <div className="px-6 pb-5 text-xs sm:text-sm text-[#525B73] ff_poppins leading-relaxed border-t border-gray-50 pt-3">
                  {faq.answer}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CountryFaqs;

